export default __webpack_public_path__ + "static/ambient-light-d1e143bf996d7207ee966321b5b88276.png";